import React from 'react'
import Image from '../../Image'
import { Tab, Tabs } from '@mui/material'
import { guidancePageContant } from '../../../config/pageContent'
import Text from '../../Text'
import { medias } from '../../../config/Resources'

const Face9 = () => {
    const [value, setValue] = React.useState(0);
 

    const handleChange = (event: any, newValue: any) => {
      setValue(newValue);
    };
  return (
    <div className='pt-[69px] pb-[99px] flex justify-center flex-col items-center'>
        <div>
          <Text className='text-[47px] font-bold'>
            {guidancePageContant.Face5.designRoadMap}
          </Text>
        </div>
        <div className='mt-[71px] mb-[46px]'>
          <Tabs value={value} classes={{
            indicator: "!bg-none !bg-transparent"
          }} onChange={handleChange} className='border border-[#00000040]  rounded-[13px] px-[16px] py-[14px] ' aria-label="basic tabs example">

            {
              guidancePageContant.Face7.tabs.map((items) => {
                return <Tab
                  className='!h-[78px] !w-[281px]'
                  classes={{
                    selected: "!bg-[#2771E7] !text-white !rounded-[11px] !border-none"
                  }}
                  label={<>
                    <Text className='text-[20px] font-medium'>
                      {items.Title}
                    </Text>
                  </>
                  } />
              })
            }
          </Tabs>
        </div>
        <Image
          src={medias.images.guidance.Face7.Universities}
          alt="University"
        />
      </div>
  )
}

export default Face9